<template src="@/templates/bookings/bookingDecline.html"></template>

<script>
import { mapActions } from "vuex";

export default {
  name: "BookingDecline",
  data() {
    return {
      declineMessage:
        "Thank you for telling us that you have declined this particular job offer.<br> New jobs are added in real time daily.<br>Please also check Available Bookings menu for any other jobs that may be available.",
    };
  },
  created() {
    this.updateHideAll();
    this.updateScrollStatus(false);
  },
  methods: {
    ...mapActions(["updateHideAll", "updateScrollStatus"]),
  },
};
</script>

<style scoped>
#ulBookingDeclineInfo {
  list-style: none;
  text-align: left;
  background-color: #cbe7f5;
  padding: 15px;
  border: 1px solid #4dabd3;
}

#ulBookingDeclineInfo li {
  margin-bottom: 20px;
  color: #407b98;
}
</style>
